import script from "./EducationView.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationView.vue?vue&type=script&setup=true&lang=js"

import "./EducationView.vue?vue&type=style&index=0&id=15deaa75&lang=css"

const __exports__ = script;

export default __exports__